<template>
  <svg
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.99996 60.9601L2.07996 57.9201L3.51996 54.7201L5.59996 52.1601L3.19996 47.8401L2.07996 42.4001L0.959961 34.0801L1.43996 29.4401L3.19996 21.4401L6.07996 15.8401L3.67996 10.7201V7.36012L5.43996 4.96012L8.47996 3.52012L11.04 4.16012L15.52 7.36012L24.32 2.88012L34.56 1.12012L41.28 1.44012L50.4 4.96012L57.12 2.24012L62.24 5.60012L58.72 12.4801L62.72 22.7201V33.6001L60.32 44.6401L56.8 50.7201L61.12 57.4401L59.04 60.3201L55.52 62.0801L49.76 59.0401L41.92 62.0801L31.04 63.0401L21.6 62.4001L15.04 60.3201L6.39996 62.7201L3.99996 60.9601Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.3173 0.972292C26.388 1.54797 19.9358 3.79405 17.1845 5.89261C15.8689 6.89613 15.6302 6.91117 14.8497 6.03853C13.9736 5.05901 12.2363 4.02477 10.4593 3.42509C8.99822 2.93165 8.83118 2.93741 7.23374 3.53517C5.96846 4.00845 5.20846 4.58285 4.18126 5.84269C2.9147 7.39661 2.8267 7.62637 2.98702 8.96013C3.15406 10.3509 4.85998 14.908 5.42478 15.4728C5.5803 15.6283 5.1531 16.5979 4.4491 17.6872C3.76014 18.7528 3.05422 20.2133 2.88014 20.9326C2.70638 21.6517 2.40014 22.6721 2.19982 23.2001C1.35758 25.4213 0.650697 29.7573 0.645577 32.7326C0.634377 39.3115 1.9883 46.7624 3.80494 50.1163L4.76462 51.8881L3.70062 53.3841C3.11566 54.2069 2.32846 55.492 1.95182 56.2401L1.26702 57.6001L1.89774 58.8363C2.6411 60.2933 5.58222 63.0401 6.39886 63.0401C6.71214 63.0401 8.17262 62.7 9.6443 62.2846C15.4597 60.6421 14.9953 60.6869 17.1397 61.5633C20.7896 63.0555 23.9422 63.5217 30.2401 63.5019C38.7483 63.4747 45.5211 62.2843 48.4152 60.307C49.0833 59.8504 49.7313 59.5224 49.8552 59.5784C49.979 59.6344 51.3515 60.3819 52.9054 61.2398C56.1672 63.0405 56.1329 63.0443 59.1502 60.5627C61.5384 58.5989 62.1873 57.7425 61.956 56.8606C61.8552 56.4753 60.8277 54.9121 59.6728 53.387L57.5729 50.6139L58.5457 49.0328C61.5624 44.1304 63.508 36.0993 63.4859 28.6401C63.4673 22.2696 62.6379 18.8769 59.9909 14.3467C58.9989 12.6491 58.9662 12.5016 59.4776 12.0385C60.2523 11.3374 62.7201 6.61357 62.7201 5.83181C62.7201 5.36941 61.9454 4.66349 60.0606 3.40973C57.5464 1.73645 57.3333 1.65549 56.1477 1.92301C55.4581 2.07853 53.8734 2.72365 52.6261 3.35661L50.3585 4.50765L46.8593 2.93517C44.9349 2.07053 42.4123 1.20013 41.2539 1.00141C38.9285 0.602372 34.5921 0.589572 31.3173 0.972292ZM40.7384 1.96493C43.428 2.39117 49.1352 4.94413 52.1918 7.08845C54.6651 8.82317 57.8331 12.4961 59.3563 15.3953L60.5259 17.6206L59.5429 18.5387C58.411 19.5963 58.3899 19.8142 59.0533 23.6577C59.459 26.0094 59.4846 27.1227 59.1976 29.9454C58.7374 34.4677 58.0379 38.1547 57.2289 40.3201C56.0741 43.4113 56.0904 43.7381 57.4702 45.1509L58.7 46.4104L58.0702 47.5915C56.2667 50.9723 50.9995 57.0561 48.267 58.9144C45.9925 60.4613 43.0987 61.2577 37.2801 61.9387C27.3493 63.1009 21.8001 62.4821 15.1499 59.4705C12.179 58.1253 10.9448 57.3595 9.36622 55.883C7.24942 53.9032 4.83246 50.3592 4.0107 48.0299C3.38766 46.2645 3.39502 46.0801 4.08878 46.0801C5.65486 46.0801 6.55406 44.3633 5.76238 42.8846C5.58766 42.5579 5.21102 40.7317 4.92526 38.8254C4.2987 34.6465 4.46862 31.5912 5.58926 26.8801C6.66478 22.3592 6.65358 21.0459 5.53134 20.1633L4.66254 19.4798L5.45134 17.9915C7.12686 14.8302 16.2133 7.13933 21.0225 4.81197C26.4987 2.16173 34.5995 0.991812 40.7384 1.96493ZM59.1429 4.06029C60.3182 4.88525 61.3352 5.60045 61.4027 5.64941C61.6283 5.81357 59.6888 10.2472 59.0401 11.0501L58.4001 11.8424L56.7643 9.84109C55.8648 8.74061 54.3237 7.26413 53.3397 6.56013C52.356 5.85613 51.5438 5.19597 51.5355 5.09357C51.5189 4.89165 56.3096 2.56141 56.7429 2.56045C56.8872 2.56045 57.9672 3.23501 59.1429 4.06029ZM11.4325 5.00557C12.9304 5.71693 14.4001 7.04397 14.4001 7.68493C14.4001 7.81581 13.5835 8.53965 12.5854 9.29325C11.5873 10.0469 9.76846 11.6481 8.54318 12.8517C7.3179 14.0555 6.27502 15.0401 6.22574 15.0401C6.11822 15.0401 4.68654 11.2094 4.1643 9.52525C3.66062 7.89997 3.91054 7.33005 5.85294 5.67757C8.30894 3.58829 8.41966 3.57485 11.4325 5.00557ZM56.5355 4.37165C56.419 4.48781 56.6472 4.74349 57.0421 4.93965C58.0293 5.42989 58.1297 6.53709 57.243 7.15821C56.6069 7.60365 56.5889 7.68045 57.0769 7.86765C57.8011 8.14573 58.8801 7.14989 58.8801 6.20301C58.8801 5.03597 57.1905 3.71629 56.5355 4.37165ZM6.61358 6.61357C6.1851 7.04205 6.41838 7.36013 7.1611 7.36013C8.28366 7.36013 8.82222 8.14573 8.3739 9.12973C7.95054 10.059 8.31758 10.1672 9.07054 9.33485C9.77422 8.55725 9.7387 7.81869 8.96014 7.04013C8.33774 6.41773 7.0443 6.18253 6.61358 6.61357ZM31.8401 7.07597C30.083 7.25517 22.9352 9.63117 20.6401 10.7992C19.2197 11.5217 16.0305 14.1192 14.3259 15.9416C11.1605 19.3256 9.52718 22.5902 8.61326 27.3595C7.83982 31.3953 7.83662 34.9982 8.60174 39.6801C9.32366 44.0965 10.2997 45.9883 13.7752 49.7099C16.4299 52.5525 19.6846 54.6865 22.8801 55.6795C26.7672 56.8872 35.7729 56.6286 38.8145 55.2222C39.3787 54.9614 40.6667 54.444 41.6769 54.0721C43.6475 53.3473 48.4302 49.8526 50.1816 47.8581C52.5141 45.2014 53.4328 43.4005 54.4472 39.4968C55.6088 35.0251 55.9873 29.5685 55.3813 26.0315C54.6261 21.6273 53.2021 17.7598 51.3038 14.9582C48.7896 11.2475 48.1777 10.6712 45.2373 9.24429C41.3736 7.36941 36.5761 6.59277 31.8401 7.07597ZM61.404 19.9201C62.4427 23.1579 62.6606 30.2209 61.8888 35.6219C61.3384 39.4709 59.6673 45.1211 59.0798 45.1185C58.8821 45.1176 58.2981 44.779 57.7819 44.3662L56.8437 43.6155L57.6721 41.0878C59.3313 36.0238 60.0977 27.9352 59.5291 21.4878C59.4033 20.0629 59.4808 19.7003 59.9902 19.3278C60.8667 18.6869 61.0305 18.7553 61.404 19.9201ZM5.46638 20.8001C5.91054 20.8001 5.81038 22.9477 5.25742 25.2801C4.22414 29.6395 3.81646 32.2379 3.81678 34.4622C3.8171 37.0737 4.60494 42.4213 5.17262 43.6673C5.60174 44.6091 5.37646 44.9397 4.1019 45.2395C3.4475 45.3934 3.20718 45.3083 3.08974 44.8808C1.73966 39.9595 1.2043 32.0443 1.94702 27.979C2.52462 24.8161 4.17806 20.4184 4.71214 20.6235C4.96526 20.7208 5.30478 20.8001 5.46638 20.8001ZM58.3973 53.9201C59.2203 54.9761 60.0997 56.2331 60.3518 56.7137C60.8008 57.5697 60.7707 57.6254 58.835 59.5137C56.9605 61.3422 55.6913 61.9147 55.2161 61.1461C55.1163 60.9845 54.0952 60.3265 52.947 59.6846L50.8593 58.5173L51.6769 57.5457C53.3339 55.5765 56.7499 51.8433 56.8241 51.9205C56.8661 51.9643 57.5742 52.8641 58.3973 53.9201ZM9.33326 57.3582C10.0961 57.9771 11.4078 58.8293 12.2488 59.252L13.7771 60.0203L10.3288 61.0504C8.43182 61.6171 6.69678 62.0805 6.4731 62.0805C5.9099 62.0801 2.56014 58.5147 2.56014 57.9157C2.56014 57.6478 2.92014 56.899 3.36014 56.2513C3.80014 55.604 4.16014 54.9787 4.16014 54.8622C4.16014 54.7457 4.47342 54.3249 4.85614 53.9272L5.55214 53.2043L6.74926 54.7185C7.4075 55.5515 8.57038 56.7393 9.33326 57.3582ZM56.9601 56.2542C56.9601 57.4853 56.2597 58.052 55.0395 57.8081C53.9617 57.5925 53.7547 58.0433 54.699 58.5489C56.3883 59.4529 58.0417 58.4421 57.8625 56.6149C57.7297 55.2593 56.9601 54.9521 56.9601 56.2542ZM5.18414 57.3441C4.18318 58.3451 5.21646 59.9317 6.77166 59.7825C8.16334 59.6491 8.25614 58.7483 6.88014 58.7317C6.03406 58.7214 5.92718 58.6158 5.9803 57.8401C6.04526 56.8917 5.79342 56.7349 5.18414 57.3441Z"
      fill="black"
    />
    <circle cx="31.9996" cy="32" r="22.4" :fill="active ? '#019CE7' : 'currentColor'" />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="9"
      y="9"
      width="46"
      height="46"
    >
      <circle cx="31.9996" cy="32" r="22.4" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0)">
      <rect
        x="16"
        y="15.6799"
        width="32"
        height="2.56"
        fill="url(#paint0_radial)"
        fill-opacity="0.75"
      />
      <rect
        x="12.7998"
        y="20.7999"
        width="38.4"
        height="2.56"
        fill="url(#paint1_radial)"
        fill-opacity="0.75"
      />
      <rect
        x="6.39941"
        y="25.9199"
        width="51.2"
        height="2.56"
        fill="url(#paint2_radial)"
        fill-opacity="0.75"
      />
      <rect
        x="6.39941"
        y="31.04"
        width="51.2"
        height="2.56001"
        fill="url(#paint3_radial)"
        fill-opacity="0.75"
      />
      <rect
        x="6.39941"
        y="36.16"
        width="51.2"
        height="2.56"
        fill="url(#paint4_radial)"
        fill-opacity="0.75"
      />
      <rect
        x="12.7998"
        y="41.28"
        width="38.4"
        height="2.56"
        fill="url(#paint5_radial)"
        fill-opacity="0.75"
      />
      <rect
        x="16"
        y="46.4"
        width="32"
        height="2.56"
        fill="url(#paint6_radial)"
        fill-opacity="0.75"
      />
    </g>
    <path
      d="M15.0449 32.9599L24.1329 29.1967L15.0449 25.4335V21.8239L27.8449 27.3535V30.8863L15.0449 36.4159V32.9599Z"
      :fill="active ? 'white' : '#848484'"
    />
    <path
      d="M35.5254 30.8863V27.3535L48.3254 21.8239V25.2799L39.2374 29.0431L48.3254 32.8063V36.4159L35.5254 30.8863Z"
      :fill="active ? 'white' : '#848484'"
    />
    <path
      d="M38.8732 40.6363C38.8732 41.1611 38.7964 41.7051 38.6428 42.2683C38.4892 42.8315 38.1756 43.3499 37.702 43.8235C37.2156 44.2971 36.5244 44.6875 35.6284 44.9947C34.7196 45.2891 33.51 45.4363 31.9996 45.4363C30.4892 45.4363 29.286 45.2891 28.39 44.9947C27.4812 44.6875 26.79 44.2971 26.3164 43.8235C25.83 43.3499 25.51 42.8315 25.3564 42.2683C25.2028 41.7051 25.126 41.1611 25.126 40.6363C25.126 40.1115 25.2028 39.5675 25.3564 39.0043C25.51 38.4411 25.83 37.9227 26.3164 37.4491C26.79 36.9755 27.4812 36.5915 28.39 36.2971C29.286 35.9899 30.4892 35.8363 31.9996 35.8363C33.51 35.8363 34.7196 35.9899 35.6284 36.2971C36.5244 36.5915 37.2156 36.9755 37.702 37.4491C38.1756 37.9227 38.4892 38.4411 38.6428 39.0043C38.7964 39.5675 38.8732 40.1115 38.8732 40.6363ZM36.5692 40.6363C36.5692 40.1755 36.4348 39.8043 36.166 39.5227C35.8844 39.2411 35.526 39.0299 35.0908 38.8891C34.6556 38.7355 34.1692 38.6395 33.6316 38.6011C33.0812 38.5499 32.5372 38.5243 31.9996 38.5243C31.462 38.5243 30.9244 38.5499 30.3868 38.6011C29.8364 38.6395 29.3436 38.7355 28.9084 38.8891C28.4732 39.0299 28.1212 39.2411 27.8524 39.5227C27.5708 39.8043 27.43 40.1755 27.43 40.6363C27.43 41.0971 27.5708 41.4683 27.8524 41.7499C28.1212 42.0315 28.4732 42.2491 28.9084 42.4027C29.3436 42.5435 29.8364 42.6395 30.3868 42.6907C30.9244 42.7291 31.462 42.7483 31.9996 42.7483C32.5372 42.7483 33.0812 42.7291 33.6316 42.6907C34.1692 42.6395 34.6556 42.5435 35.0908 42.4027C35.526 42.2491 35.8844 42.0315 36.166 41.7499C36.4348 41.4683 36.5692 41.0971 36.5692 40.6363Z"
      :fill="active ? 'white' : '#848484'"
    />
    <defs>
      <radialGradient
        id="paint0_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32 16.9599) rotate(90) scale(1.28 16)"
      >
        <stop stop-color="#555555" />
        <stop offset="1" stop-color="#6F6F6F" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.9998 22.0799) rotate(90) scale(1.28 19.2)"
      >
        <stop stop-color="#555555" />
        <stop offset="1" stop-color="#6F6F6F" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.9994 27.1999) rotate(90) scale(1.28 25.6)"
      >
        <stop stop-color="#555555" />
        <stop offset="1" stop-color="#6F6F6F" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.9994 32.32) rotate(90) scale(1.28 25.6)"
      >
        <stop stop-color="#555555" />
        <stop offset="1" stop-color="#6F6F6F" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.9994 37.44) rotate(90) scale(1.28 25.6)"
      >
        <stop stop-color="#555555" />
        <stop offset="1" stop-color="#6F6F6F" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint5_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.9998 42.56) rotate(90) scale(1.28 19.2)"
      >
        <stop stop-color="#555555" />
        <stop offset="1" stop-color="#6F6F6F" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32 47.68) rotate(90) scale(1.28 16)"
      >
        <stop stop-color="#555555" />
        <stop offset="1" stop-color="#6F6F6F" stop-opacity="0" />
      </radialGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "IconFeedback1",
  props: {
    active: Boolean,
  }
};
</script>
